"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const change_1 = require("../change");
const getDomRange_1 = __importDefault(require("../selection/getDomRange"));
function onBeforeInput(editorState, _event) {
    const event = _event;
    let newEditorState = editorState;
    const domRange = getDomRange_1.default(editorState.list);
    if (domRange == null)
        return newEditorState;
    const { collapsed, start, end } = domRange;
    event.preventDefault();
    event.stopPropagation();
    if (event.inputType === 'insertText' && event.data != null && event.data.length === 1) {
        newEditorState = change_1.insertCharacter(newEditorState, start, end, event.data);
    }
    else if (event.inputType === 'insertText') {
        newEditorState = change_1.insertText(newEditorState, start, end, event.data || '');
    }
    else if (event.inputType === 'insertFromPaste') {
        newEditorState = change_1.insertText(newEditorState, start, end, event.data || '');
    }
    else if (event.inputType === 'insertCompositionText') {
        newEditorState = change_1.insertText(newEditorState, start, end, event.data || '');
    }
    else if (event.inputType === 'insertLineBreak') {
        newEditorState = change_1.splitBlock(newEditorState, start, end);
    }
    else if (!collapsed && event.inputType === 'deleteContentBackward') {
        newEditorState = change_1.removeRange(editorState, start, end);
    }
    else if (event.inputType === 'deleteContentBackward') {
        newEditorState = change_1.backspace(editorState, start, end);
    }
    else if (event.inputType === 'deleteWordBackward') {
        newEditorState = change_1.backspaceToPrevWord(editorState, start, end);
    }
    else if (event.inputType === 'deleteSoftLineBackward') {
        newEditorState = change_1.backspaceToBlockStart(editorState, start, end);
    }
    else if (event.inputType === 'deleteContentForward') {
        newEditorState = change_1.deleteForward(editorState, start, end);
    }
    return newEditorState;
}
exports.default = onBeforeInput;
//# sourceMappingURL=onBeforeInput.js.map